import { Tab, Tabs } from '@mui/material';
import clsx from 'clsx';
import { TabsEfexProps } from './TabsEfex.type';
import TabsEfexStyles from './TabsEfex.styles';

export const TabsEfex = ({
  currentTab = 0,
  tabIndices = [],
  tabLabels = [],
  isMobile = false,
  onChangeTabs,
}: TabsEfexProps) => {
  if (!tabIndices.length) return null;

  return (
    <Tabs
      scrollButtons="auto"
      variant="scrollable"
      value={currentTab}
      onChange={onChangeTabs}
      aria-label="Account tabs"
      className={clsx(TabsEfexStyles.wrapper, {
        [TabsEfexStyles.mobileTabElement]: isMobile,
      })}
    >
      {tabIndices.map((tabIndex, index) => (
        <Tab
          key={`tab-${tabIndex}`}
          label={tabLabels[index]}
          disableRipple
          className={TabsEfexStyles.tabElement}
          value={tabIndex}
        />
      ))}
    </Tabs>
  );
};

export default TabsEfex;
